import { cn, Text } from "@artprov/design-system";
import PropTypes from "prop-types";

export const CardLinks = ({ aplicativo }) => {
  const icon = new URL(
    `../../assets/icons/${aplicativo.icono}`,
    import.meta.url
  ).href;

  return (
    <a
      className={cn(
        "flex items-center justify-between",
        "rounded-[6px] border border-tertiary-80 p-3",
        "w-full"
      )}
      href={aplicativo.url}
      target="_blank"
      rel="noopener"
    >
      <div className="flex items-center gap-2">
        <img src={icon} className="size-6" alt={aplicativo.titulo} />
        <Text variant="subtitle2" className="text-primary-20">
          {aplicativo.titulo}
        </Text>
      </div>
    </a>
  );
};

CardLinks.propTypes = {
  aplicativo: PropTypes.shape({
    url: PropTypes.string,
    icono: PropTypes.string,
    titulo: PropTypes.string,
  }),
};